import { inject } from '@angular/core';
import { AuthenticationService } from '../services';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';

export const canActivateRoleRedirect = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): UrlTree => {
  const router = inject(Router);

  const currentUserStr = localStorage.getItem('currentUser');
  let role = '';

  if (currentUserStr) {
    try {
      const currentUser = JSON.parse(currentUserStr);
      role = currentUser?.role;
    } catch (e) {
      console.error('Error parsing currentUser in role redirect guard', e);
    }
  }

  // ✅ Step 1: If user is logged in and last route is stored, redirect to that
  // Only resume the last page for a signed-in user (token present);
  // otherwise fall through to the login page below.
  const lastRoute = localStorage.getItem('lastRoute');
  const hasToken = !!localStorage.getItem('access_token');
  const isRealPage = !!lastRoute && lastRoute !== '/' && !lastRoute.startsWith('/?') && !lastRoute.includes('/auth');
  if (hasToken && isRealPage) {
    return router.parseUrl(lastRoute!);
  }

  // Signed in but no page to resume → the default page for the role
  // (the root '/' itself has nothing to show).
  if (hasToken) {
    const home = inject(AuthenticationService).roleHomeUrl();
    if (home) return router.parseUrl(home);
  }

  // ✅ Step 2: Fallback to role-based login redirect
  let redirectUrl = '/auth';

  if (role === 'client_admin') {
    redirectUrl = '/auth/login';
  } else if (role === 'system_admin') {
    redirectUrl = '/auth/sign-in';
  } else if (['HR', 'TL', 'Recruiter'].includes(role)) {
    redirectUrl = '/auth/emp-login';
  } else if (role === 'Candidate') {
    redirectUrl = '/auth/sign-in';
  }

  return router.parseUrl(redirectUrl);
};

